export const LABEL_CSS_CLASSES = {
  PERCENT_VALUE: 'UI_CAPTION_BOLD',           // Main percent/value display
  COUNT_VALUE: 'UI_CAPTION_SEMIBOLD_DF',         // Count display for standard/grouped
  LABEL_TEXT: 'UI_CAPTION',                   // Label text for standard/grouped
  STACKED_LABEL: 'UI_CAPTION_SEMIBOLD_DF',    // All elements in stacked charts
  GROUP_LABEL: 'UI_CAPTION_SEMIBOLD_DF',         // Group category label
} as const;

export interface BaseBarChartUIConfigs {
  barHeight: number;
  stackedBarHeight: number;
  labelToBarGap: number;
  labelHeight: number;
  gapBetweenTwoLabels: number;
  labelToNextBarGap: number;
  barRadius: number;
  gapBetweenBarSections: number;
  stackedGapBetweenBars: number;
  hoverRectStrokeWidth: number;
  marginLeft: number;
  marginRight: number;
  gapBetweenBarsInGroup: number;
  gapBetweenGroups: number;
  labelLeftSpacing: number;
  barRadiusStacked: number;
  stackedLabelToBarGap: number;
  groupedLabelToBarGap: number;
  breakdownSortByLabel: boolean;
  minBarWidthForZeroValues: number;
  labelPercentWidth: number;
  gapBetweenSummarizedBars: number;
  labelElementGap: number;
}

/**
* if any changes are being made to the spacing and such of 
  this comps design, all these properties need to be carefully 
  observed and tweaked to ensure no ui has gotten warped due to sideeffects
*/
export const _base_barchart_ui_configs: BaseBarChartUIConfigs = {
    // ===== BAR CHART =====
    barHeight: 24, // Controls the height of individual bars
    labelToBarGap: -16, // Controls the gap between bar labels and the bars themselves
    labelHeight: 16.5667, // Controls the height of labels
    gapBetweenTwoLabels: 2, // Controls the spacing between two consecutive labels

    labelToNextBarGap: 12, // Controls the gap between labels and the next bar section    
    barRadius: 4, // Controls the radius of bar corners for rounded appearance
    gapBetweenBarSections: -10, // Controls the gap between different bar sections
    hoverRectStrokeWidth: 1, // Controls the stroke width of hover rectangles
    gapBetweenSummarizedBars: 0.6, // negative rem value, controls the gap between summarized bar and main (top) bars
    
    // ===== GROUPED BAR CHART =====
    gapBetweenBarsInGroup: 2, // Controls the spacing between individual bars within the same group
    gapBetweenGroups: -2, // Controls the spacing between different groups in grouped bar chart
    groupedLabelToBarGap: -10, // Controls the gap between group labels and their corresponding bars
    
    breakdownSortByLabel: true, // Controls whether breakdown data should be sorted by label
    minBarWidthForZeroValues: 2, // Minimum visual width (in pixels) for zero-value bars across all chart types

    // ===== STACKED BAR CHART =====
     barRadiusStacked: 0,

    stackedBarHeight: 16, // Controls the height of bars specifically for stacked bar charts
    stackedGapBetweenBars: -2, // Controls the gap between bars specifically for stacked bar charts
    stackedLabelToBarGap: -11, // Controls the gap between stacked bar labels and the bars
    
    // ===== COMMON =====
    marginLeft: 0, // Controls the left margin of the entire chart
    marginRight: 0, // Controls the right margin of the entire chart
    labelLeftSpacing: 7, // Controls the left spacing of labels from the chart edge
    labelPercentWidth: 10, // Controls how much width the percentage value takes in the label
    labelElementGap: 10, // Controls the gap between percent, count, and label elements
    
  };